import { UseQueryOptions } from '@tanstack/react-query';

import { equipmentBrowserGetEquipmentBulkEditView } from '@repo/sdk/funcs/equipmentBrowserGetEquipmentBulkEditView';
import { BulkEditView } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetEquipmentBulkEditViewRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetEquipmentBulkEditViewQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  deviceIds?: string[];
  deviceKind?: string;
}

export const getEquipmentBulkEditViewQuery = ({
  agentId,
  client,
  deviceIds,
  deviceKind,
}: GetEquipmentBulkEditViewQueryProps): UseQueryOptions<
  BulkEditView,
  SDKError,
  BulkEditView | undefined
> => {
  return {
    enabled: !!agentId && !!deviceKind,
    queryKey: [agentId, 'getEquipmentBulkEditView', deviceKind, deviceIds],
    queryFn: () =>
      client<GetEquipmentBulkEditViewRequest, BulkEditView>({
        gaiaFunc: equipmentBrowserGetEquipmentBulkEditView,
        request: {
          agentId: agentId!,
          deviceKind: deviceKind!,
          deviceIds: deviceIds,
        },
      }),
    staleTime: Infinity,
  };
};
